import { GPL } from './EmbedTool';
import { connect } from 'react-redux';
const mapStateToProps = (state) => ({
  companies: state.companyReducer.companies,
  users: state.userReducer.users
});
const EMBT = connect(mapStateToProps, null)(GPL);
export default EMBT;
